import ResultsCounter from './ResultsCounter';
import { returnErrorSel } from 'src/store/modules/returns';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => {
  return {
    error: returnErrorSel(state)
  };
};

export default connect(mapStateToProps)(ResultsCounter);
